export function isPortalDomainInCurrentEnvironment(portalDomain: string, currentHostname: string): boolean {
    const hostnameParts = currentHostname.toLowerCase().split('.');
    const environmentDomain = hostnameParts.slice(-3).join('.');
    const isPersonalEsonoEnvironment = hostnameParts.length > 3 && 'esono.net' === hostnameParts.slice(-2).join('.');

    return !isPersonalEsonoEnvironment || portalDomain.toLowerCase().endsWith(`.${environmentDomain}`);
}
